import { Box, Button, Chip } from "@mui/material";
import { useNotification } from "../../State/Hooks/notificationHooks";
import { ITimeFilter } from "../../Typings/SearchFilters";
import { TIME_FILTERS } from "./Hooks/useTimeFilterHook";

const defaultTimeFilter = TIME_FILTERS["all-time-button"];

export default function FilterChips({
  tags,
  timeFilter,
  handleTagsChange,
  handleTimeFilterChange,
}: {
  tags: string[];
  timeFilter: ITimeFilter;
  handleTagsChange: (tags: string[]) => void;
  handleTimeFilterChange: (timeFilter: ITimeFilter) => void;
}) {
  const hasTagFilters = tags.length > 0;
  const hasTimeFilter = timeFilter.name !== "All Time";
  const { displaySuccess } = useNotification();
  return (
    <>
      {(hasTimeFilter || hasTagFilters) && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            mb: 2,
            justifyContent: "flex-start",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          {hasTimeFilter && (
            <Chip
              data-test="filter-chip-date"
              size="medium"
              color="primary"
              label={
                <>
                  <b>Date added:</b> {timeFilter.name}
                </>
              }
              onDelete={() => handleTimeFilterChange(defaultTimeFilter)}
            />
          )}
          {hasTagFilters &&
            tags.map((tag, index) => (
              <Chip
                data-test="filter-chip-tag"
                key={"filter-tag-" + index}
                size="medium"
                color="primary"
                label={
                  <>
                    <strong>Tag:</strong> {tag}
                  </>
                }
                onDelete={() => handleTagsChange(tags.filter((c) => c.toLowerCase() !== tag.toLowerCase()))}
              />
            ))}
          <Button
            variant="text"
            color="primary"
            onClick={() => {
              handleTimeFilterChange(defaultTimeFilter);
              handleTagsChange([]);
              displaySuccess("Filters Cleared!");
            }}
            data-test="filter-button-reset-filters"
          >
            CLEAR ALL
          </Button>
        </Box>
      )}
    </>
  );
}
